import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
//import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiUrl = null;
  apiUrlPrivacyPolicy = null;
  tokenKey = null;
  apiUrlApp = null;
  apiUrlAppDev = null;
  serviceDetailsFromProfile = null;
  constructor(private http: HttpClient) {}
  getAccessToken(){
    return localStorage.getItem('access_token');
  }
  private getHeaders(file = false,cache=false) {
    let headers = new HttpHeaders();
    if(!file){
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    if(cache){
      headers = new HttpHeaders({ 'cache-response': 'true','Content-Type': 'application/json' });
    }
    headers = headers.set('Authorization', `Bearer ${this.getAccessToken()}`);
    return headers;
  }
  getApi(url: string):Observable<any> {
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  postApi(url: string,postValue:any, file = false,cache=false):Observable<any> {
    return this.http.post(url, postValue,{ headers: this.getHeaders(file,cache) }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  putApi(url: string,postValue:any, file = false,cache=false):Observable<any> {
    return this.http.put(url, postValue,{ headers: this.getHeaders(file,cache) }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  deleteApi(url: string):Observable<any> {
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  catchError(err) {    
    throw err;
  }
  getUserProfile(userId) {
    // var data = {
    //   "userId": userId,
    //   "appId": appId
    // }
    return this.getApi(this.apiUrl+"Users/GetUserProfile/"+userId);
  }
  initiatePasswordReset(data) {
    return this.postApi(this.apiUrl+`v0.2/Account/InitiatePasswordReset`,data);
  }
  uploadUserProfileImage(data) {
    return this.postApi(this.apiUrl+`Users/UploadUserProfileImage`,data, true);
  }
  uploadUserProfileDetails(data) {
    return this.postApi(this.apiUrl+`Users/UpdateUserDetails`,data, true);
  }
  updateUserProfileSettings(data) {
    return this.postApi(this.apiUrl+`Users/UpdateUserPrivateSetting`,data, true);
  }
  getPrivacyPolicyByCountry(postData) {
    console.log("IN");
    return this.postApi(this.apiUrlPrivacyPolicy + "MasterData/GetPrivatePolicy",postData,true);
  }
  getTermsandConditionByCountry(postData) {
    console.log("INOI");
    return this.postApi(this.apiUrlPrivacyPolicy + "MasterData/GetTermConditionPolicy",postData,true);
  }
  getFacilityByCRMId(id) {
    return this.getApi(this.apiUrl + "Facility/GetFacilityByCRMId/" + id);
  }
  updateUserProfileConsentData(data) {
    return this.postApi(this.apiUrl+`Users/UpdateUserProfileConsent`,data, true);
  }
  updateUserPrivateSettingData(data) {
    return this.postApi(this.apiUrl+`Users/UpdateUserPrivateSetting`,data, true);
  }
  updateFacilitySubscriptionSetup(flag,commData) {
    return this.putApi(this.apiUrl + "AppSubscription/UpdateFacilitySubscriptionSetup/"+flag, commData);
  }
  delUserRquest(userId) {
    return this.getApi(this.apiUrl+`Users/DeleteUserRequest/${userId}`);
  }
  generateUserOTP(userId) {
    return this.getApi(this.apiUrl+`Users/GenerateUserOTP/${userId}`);
  }
  changePasswordRequest(formData) {
    return this.postApi(this.apiUrl+`Account/ChangePasswordOtp`,formData);
  }
  delUserRecord(otp) {
    return this.deleteApi(this.apiUrl+`Users/DeleteUser/${otp}`);
  }
  updateUserPreferredLanguage(language){
    return this.putApi(this.apiUrl+`Users/UpdateUserPreferredLanguage/${language}`,'');
  }
  //For DevPortal service resirection
  redirectToService(data) {
    return this.postApi(this.apiUrlAppDev+`ServiceCatalog/GetServiceCatalogById`,data,true);
  }
  changePassword(data) {
    return this.postApi(this.apiUrl+`Account/ChangePassword`,data, true);
  }
  profileEditAuth(data) {
    return this.postApi(this.apiUrl+`Account/UserProfileEditAuth`,data, true);
  }
  updateConsent(data) {
    return this.postApi(this.apiUrl+`Users/UpdateUserConsentAgreement`,data,true);
  }
  unSubscribeApp(data) {
    //return this.postApi(this.apiUrl+`AppSubscription/UpdateSubScriptionStatus/${uid}`,data, true);
    return this.postApi(this.apiUrl+`AppSubscription/AddDeSubScriptionRequest`,data);
  }
  unSubscribeAppNoApproval(data) {
    //return this.postApi(this.apiUrl+`AppSubscription/UpdateSubScriptionStatus/${uid}`,data, true);
    return this.postApi(this.apiUrl+`AppSubscription/DesubscribeRequest`,data);
  }
  getFacilityAppSubscriptionAgreementPost(formData) {
    return this.postApi(this.apiUrlPrivacyPolicy + "MasterData/GetFacilityAppSubscriptionAgreement", formData);
  }
  getFacilityAppSubscriptionAgreement(appId, facilityId) {
    return this.getApi(this.apiUrl + "MasterData/GetFacilityAppSubscriptionAgreement/" + appId + "/" + facilityId);
  }
  logout(formData) {
    return this.postApi(this.apiUrl + 'Account/LogOut',formData, true);
  }
}
